/* eslint-disable @typescript-eslint/ban-ts-comment */
type HeapPropertyValue = number | string
type HeapLoadOptions = {
  secureCookie: boolean
  disableTextCapture: boolean
}

interface Heap {
  track: (event: string, properties?: Record<string, HeapPropertyValue>) => void
  identify: (identity: string) => void
  resetIdentity: () => void
  addUserProperties: (properties: Record<string, HeapPropertyValue>) => void
  addEventProperties: (properties: Record<string, HeapPropertyValue>) => void
  removeEventProperty: (property: string) => void
  clearEventProperties: () => void
  appid: string
  userId: string
  identity: string | null
  config: Record<string, HeapPropertyValue>
  load: (heapEnvId: HeapPropertyValue, options?: Partial<HeapLoadOptions>) => null
}

export interface WindowWithHeap extends Window {
  // TODO is there a better type for this? Do we care?
  heap: Heap
}

declare let window: WindowWithHeap

export const getHeap = () => window.heap

export function loadHeap() {
  //@ts-ignore
  window.heap = window.heap || []

  //@ts-ignore
  window.heap.load = function (e, t) {
    //@ts-ignore
    ;(window.heap.appid = e), (window.heap.config = t = t || {})
    //@ts-ignore
    const r = t.forceSSL || "https:" === document.location.protocol,
      a = document.createElement("script")
    ;(a.type = "text/javascript"),
      (a.async = !0),
      (a.src = (r ? "https:" : "http:") + "//cdn.heapanalytics.com/js/heap-" + e + ".js")
    const n = document.getElementsByTagName("script")[0]
    n.parentNode.insertBefore(a, n)
    for (
      let o = function (e) {
          return function () {
            //@ts-ignore
            // eslint-disable-next-line prefer-rest-params
            window.heap.push([e].concat(Array.prototype.slice.call(arguments, 0)))
          }
        },
        p = [
          "addEventProperties",
          "addUserProperties",
          "clearEventProperties",
          "identify",
          "resetIdentity",
          "removeEventProperty",
          "setEventProperties",
          "track",
          "unsetEventProperty"
        ],
        c = 0;
      c < p.length;
      c++
    )
      window.heap[p[c]] = o(p[c])
  }
}
